import React, { useEffect, useState } from 'react';  
import { Navigate } from 'react-router-dom';  
import { loadState } from '../stores/store';  
import { checkContestantExists } from '../api/user';  
import Dashboard from '../pages/dashboard/dashboard';
  
const ContestantRoute = ({ component: Outlet }) => {  
  const auth = loadState();  
  const userRole = auth?.user?.role;  
  const [hasContestant, setHasContestant] = useState(null);  
  
  useEffect(() => {  
    const fetchContestantStatus = async () => {  
      if (userRole === 'contestant') {  
        const result = await checkContestantExists(auth.user._id);  
        setHasContestant(result.hasContestants);  
      }  
    };  
  
    fetchContestantStatus();  
  }, [userRole, auth]);  
  
  if (hasContestant === null) {  
    return <div>Loading...</div>;  
  }  
  
  return userRole === 'contestant' && !hasContestant ? (  
    <Dashboard component={Outlet} />  
  ) : (  
    <Navigate to="/" />  
  );  
};  
  
export default ContestantRoute;  